import { useEffect, useState } from "react";

const links = [
  { href: "#home", label: "首页" },
  { href: "#ranking", label: "热门榜单" },
  { href: "#serial", label: "人气连载" },
  { href: "#featured", label: "霸榜作品" },
  { href: "#category", label: "漫画分类" },
  { href: "#faq", label: "常见问题" },
  { href: "#about", label: "关于我们" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-background-50/90 backdrop-blur-md shadow-sm" : "bg-transparent"
      }`}
    >
      <nav className="mx-auto flex w-full max-w-7xl items-center justify-between px-4 py-3 md:px-6">
        <a href="#home" className="flex items-center gap-2 whitespace-nowrap">
          <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 text-background-50">
            <i className="ri-book-open-fill text-lg"></i>
          </span>
          <span className="font-heading text-xl text-primary-600">番木瓜漫画</span>
        </a>

        <div className="hidden items-center gap-1 lg:flex">
          {links.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="whitespace-nowrap rounded-md px-3 py-2 text-sm text-foreground-700 transition-colors hover:bg-primary-100 hover:text-primary-700"
            >
              {link.label}
            </a>
          ))}
        </div>

        <div className="flex items-center gap-3">
          <a
            href="#serial"
            className="hidden whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 sm:inline-flex"
          >
            <i className="ri-fire-fill mr-1"></i>
            开始追更
          </a>
          <button
            type="button"
            aria-label="打开菜单"
            onClick={() => setOpen((v) => !v)}
            className="flex h-10 w-10 items-center justify-center rounded-md bg-background-100 text-foreground-800 lg:hidden"
          >
            <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-xl`}></i>
          </button>
        </div>
      </nav>

      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-4 pt-2 lg:hidden">
          {links.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={() => setOpen(false)}
              className="block whitespace-nowrap rounded-md px-3 py-2.5 text-sm text-foreground-700 hover:bg-primary-100 hover:text-primary-700"
            >
              {link.label}
            </a>
          ))}
        </div>
      )}
    </header>
  );
}